export default "__VITE_PUBLIC_ASSET__bd64f06f__"